import React from 'react';
import ProductService from '../services/product';
import $ from 'jquery';
import Utility from '../utilities/utility';
import AuthorizationCheck from '../auth/authorizationCheck';

class CreateProduct extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentUserRole : ''
        }
    }

    setRole = (role) => {

        this.setState({ currentUserRole : role });
    }

    async createProduct() {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let color = $('#color').val();
        let size = $('#size').val();
        let cbm = $('#cbm').val();
        let weight = $('#weight').val();
        let qtyInBox = $('#qtyInBox').val();
        let supplierUniqueId = $('#supplierUniqueId').val();
        let price = $('#price').val();
        let customerPrice = $('#customerPrice').val();
        
        try {

            if(Utility.isEmpty(name)){

                $('.messageHolder').html(

                    '<div class="alert alert-danger">Le nom du produit doit etre fourni</div>'
                );

                return;
            }

            const response = await ProductService.createProduct(name, model, brand, size, color, cbm, qtyInBox, weight, supplierUniqueId, price, customerPrice);

            if(response.ok){

                $('.messageHolder').html(

                    '<div class="alert alert-success">Produit Cré</div>'
                );
    
            }else{

                $('.messageHolder').html(

                    '<div class="alert alert-danger">Problem lors de la creation du produit</div>'
                );
            }
            
        } catch (error) {

            console.log(error);
            
            $('.messageHolder').html(

                '<div class="alert alert-danger">Problem lors de la creation du produit</div>'
            );
        }
    }


    render() {




        return (
            <div className="container create-product-wrapper mt-4">


                <AuthorizationCheck accessLevel='ADMIN' userRole= { this.setRole } />

                <h2 className="mb-3 text-center">Creer Produit </h2>


                <div className="form-wrapper">

                    <div className="messageHolder"></div>




                    <div className="form-group">
                        <input className="form-control" id="name" placeholder="Nom" />
                    </div>


                    <div className="form-group">
                        <input className="form-control" id="model" placeholder="Model" />
                    </div>




                    <div className="form-group">
                        <input className="form-control" id="brand" placeholder="Marque" />
                    </div>

                    <div className="form-group">
                        <input className="form-control" id="color" placeholder="Couleur" />
                    </div>


                    <div className="form-group">
                        <input className="form-control" id="size" placeholder="Numero" />
                    </div>

                    <div className="form-group">
                        <input className="form-control" id="cbm" placeholder="CBM" />
                    </div>

                    <div className="form-group">
                        <label className="label text-start">PRIX</label>
                        <input className="form-control" id="price" placeholder="PRIX" />
                    </div>

                    <div className="form-group">
                        <label className="label text-start">PRIX Client</label>
                        <input className="form-control" id="customerPrice" placeholder="PRIX Client" />
                    </div>

                    <div className="form-group">
                        <input className="form-control" id="qtyInBox" placeholder="Qté dans le carton" />
                    </div>

                    <div className="form-group">
                        <input className="form-control" id="weight" placeholder="Poids" />
                    </div>

                    <div className="form-group">
                        <input className="form-control" id="supplierUniqueId" placeholder="CPID" />
                    </div>

                    <div className="form-group">
                        <button className="btn btn-primary full-width" onClick={this.createProduct}>Creer</button>
                    </div>


                </div>



            </div>
        )
    }

}

export default CreateProduct;